import { Component, Input } from '@angular/core';

@Component({
  selector: 'youtube-video',
  templateUrl: './youtube-video.component.html',
  styleUrls: ['./youtube-video.component.scss'],
  standalone: false,
})
export class YoutubeVideoComponent {
  @Input() src: string = '';
  @Input() width: string = '560'; // Not used, but accepted to avoid warnings
  @Input() height: string = '315'; // Not used, but accepted to avoid warnings

  get videoId(): string {
    if (!this.src) return '';
    const match =
      this.src.match(/v=([a-zA-Z0-9_-]{11})/) ||
      this.src.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/) ||
      this.src.match(/embed\/([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : '';
  }

  get embedUrl(): string {
    return this.videoId ? `https://www.youtube.com/embed/${this.videoId}` : '';
  }
}
